import PubSub from "pubsub-js";

import PubSubTopics from "../constants/pubSubTopics";

const onPulseAnimationEnd = () => {
  PubSub.publish(PubSubTopics.pulseAnimationEnd, {});
};

export default onPulseAnimationEnd;
